import React, { useState } from 'react';
import { ReactComponent as InfoIcon } from '../../assets/icons/info-icon.svg';
import { Typography } from '../Typography/Typography';
import { KpiDeleteModal } from '../KpiDeleteModal/KpiDeleteModal';
import { KpiCalculationMethodModal } from '../KpiCalculationMethodModal/KpiCalculationMethodModal';
import { KpiTableDesktop } from './KpiTableDesktop';
import { KpiTableMobile } from './KpiTableMobile';
import { KpiRow, KpiTableProps } from './types';
import styles from './KpiTable.module.scss';

export function KpiTable(props: KpiTableProps) {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [
    isCalculationMethodModalOpen,
    setIsCalculationMethodModalOpen
  ] = useState(false);
  const [rowToDelete, setRowToDelete] = useState<KpiRow | null>(null);

  const handleDeleteClick = (row: KpiRow) => {
    setRowToDelete(row);
    setIsDeleteModalOpen(true);
  };

  const handleDeleteConfirm = () => {
    if (rowToDelete) {
      console.log('Удаление КПЭ:', rowToDelete);
    }
    setIsDeleteModalOpen(false);
    setRowToDelete(null);
  };

  const handleDeleteClose = () => {
    setIsDeleteModalOpen(false);
    setRowToDelete(null);
  };

  const handleCalculationMethodClick = () => {
    setIsCalculationMethodModalOpen(true);
  };

  const handleCalculationMethodClose = () => {
    setIsCalculationMethodModalOpen(false);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.status}>
        <InfoIcon className={styles.info} />
        <Typography variant={'text'}>
          Показатели направлены вышестоящим руководителям для согласования.
          <br />
          Редактирование таблицы на данном этапе недоступно.
        </Typography>
      </div>
      <div className={styles.desktop}>
        <KpiTableDesktop
          {...props}
          isDeleted={props.isDeleted}
          onDelete={handleDeleteClick}
          onMethodologyClick={handleCalculationMethodClick}
        />
      </div>
      <div className={styles.mobile}>
        <KpiTableMobile
          {...props}
          isDeleted={props.isDeleted}
          onDelete={handleDeleteClick}
          onMethodologyClick={handleCalculationMethodClick}
        />
      </div>

      <KpiDeleteModal
        isOpen={isDeleteModalOpen}
        onClose={handleDeleteClose}
        onConfirm={handleDeleteConfirm}
      />

      <KpiCalculationMethodModal
        isOpen={isCalculationMethodModalOpen}
        onClose={handleCalculationMethodClose}
        notification={'Текст возможного уведомления'}
      />
    </div>
  );
}
